// extracted by mini-css-extract-plugin
export default {"searchFiltr_items":"AllOrdersFilterItems_searchFiltr_items__VZ5G9"};